import React, { createRef } from "react";
import "./review.scss";
import FormTitle from "../components/formTitle/FormTitle";
import Config from "../common/Config";
import axios from "axios";
import SecondaryButton from "../components/button/SecondaryButton";
import Button from "../components/button/Button";
import Review from "./Review";
import { ClipLoader } from "react-spinners";
import InputTextField from "../components/textField/InputTextField";

class InternalReview extends Review {
  constructor(props) {
    super(props);
    this.targetRef = createRef();

    this.patientInfo1UomMetric = 1;
    this.patientInfo1UomImperial = 2;
    this.nomodificationId = 154;
    this.customerSuppliedFabricId = 22;
    this.customerSuppliedLockId = 43;
    this.customerSuppliedPlateId = 50;
    this.customerSuppliedValveId = 58;

    this.state = {
      isLoaded: false,
      accountNumber: null,
      clinicName: null,
      prosthetistName: null,
      email: null,
      poNumber: null,
      shippingAddress1: null,
      shippingAddress2: null,
      city: null,
      stateName: null,
      zip: null,
      phone: null,
      contactMethodName: null,
      shippingCarrierName: null,
      shippingMethodName: null,
      patientName: null,
      patientId: null,
      patientInfo1UOM: null,
      patientInfo1UOMName: null,
      height: null,
      weight: null,
      isBilateral: null,
      amputationLevel: null,
      kLevel: null,
      footDirection: null,
      estimatedShipDate: null,
      itemsSentIn: null,
      uOM: null,
      mPTToFloor: null,
      pmlWidth: null,
      residualLength: null,
      aboveMPT15cm: null,
      aboveMPT10cm: null,
      aboveMPT5cm: null,
      aboveMPT0cm: null,
      belowMPT5cm: null,
      belowMPT10cm: null,
      belowMPT15cm: null,
      belowMPT20cm: null,
      pml: null,
      ml: null,
      ap: null,
      iTToFloor: null,
      kCToFloor: null,
      tight5cm: null,
      tight10cm: null,
      tight15cm: null,
      tight20cm: null,
      tight25cm: null,
      tight30cm: null,
      loose5cm: null,
      loose10cm: null,
      loose15cm: null,
      loose20cm: null,
      loose25cm: null,
      loose30cm: null,
      limbLength: null,
      femurLength: null,
      flexion: null,
      adduction: null,
      castShippedSeparately: null,
      shapeCreationNotes: null,
      modification: [],
      modificationPercentage: [],
      modificationPly: [],
      trimline: [],
      socketStyle: [],
      brim: [],
      brimOther: [],
      shapeCreation: [],
      lock: [],
      lockType: [],
      valve: [],
      mountingPlate: [],
      material: [],
      foamCarving: [],
      insertMaterial: [],
      AKLynValveOption: [],
      soNumber: null,
      pendingSoNumber: "",
      customerSuppliedPlate: null,
      customerSuppliedLock: null,
      customerSuppliedValve: null,
    };
  }

  componentDidMount() {
    this.loadData();
    this.loadData2();
  }

  async loadData() {
    try {
      let config = {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token"))?.access_token,
        },
      };

      if (this.props.uniqueId != null) {
        config.headers.UniqueId = this.props.uniqueId;
      }

      let clinicInfoData = (
        await axios.get(
          Config.baseApiUrl + "clinicInfos/" + this.props.formTypeId,
          config
        )
      ).data;
      let notes = (
        await axios.get(
          Config.baseApiUrl + "notes/" + this.props.formTypeId,
          config
        )
      ).data;
      let soNumber = (
        await axios.get(
          Config.baseApiUrl + "soNumbers/" + this.props.formTypeId,
          config
        )
      ).data;

      let estimatedShipDate = (
        await axios.get(
          Config.baseApiUrl + "shipDate/" + this.props.formTypeId,
          config
        )
      ).data;

      let patientInfo1Config = {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token"))?.access_token,
        },
        params: {
          fieldNames: ["patientInfo1UOM", "height", "weight"],
        },
      };

      if (this.props.uniqueId != null) {
        patientInfo1Config.headers.UniqueId = this.props.uniqueId;
      }

      let patientInfo1Data = (
        await axios.get(
          Config.baseApiUrl + "patientInfo1s/" + this.props.formTypeId,
          patientInfo1Config
        )
      ).data;

      let fieldInputConfig = {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token"))?.access_token,
        },
        params: {
          fieldNames: [
            "amputationLevel",
            "kLevel",
            "footDirection",
            "itemsSentIn",
            "uOM",
            "mPTToFloor",
            "pmlWidth",
            "residualLength",
            "aboveMPT15cm",
            "aboveMPT10cm",
            "aboveMPT5cm",
            "aboveMPT0cm",
            "belowMPT5cm",
            "belowMPT10cm",
            "belowMPT15cm",
            "belowMPT20cm",
            "pml",
            "ml",
            "ap",
            "iTToFloor",
            "kCToFloor",
            "tight5cm",
            "tight10cm",
            "tight15cm",
            "tight20cm",
            "tight25cm",
            "tight30cm",
            "loose5cm",
            "loose10cm",
            "loose15cm",
            "loose20cm",
            "loose25cm",
            "loose30cm",
            "limbLength",
            "femurLength",
            "flexion",
            "adduction",
            "castShippedSeparately",
            "modification",
            "modificationPercentage",
            "modificationPly",
            "trimline",
            "brim",
            "brimOther",
            "shapeCreation",
            "lock",
            "lockType",
            "valve",
            "mountingPlate",
            "material",
            "notes",
            "foamCarving",
            "insertMaterial",
            "AKLynValveOption",
            "poNumber",
            "customerSuppliedPlate",
            "customerSuppliedLock",
            "customerSuppliedValve",
          ],
        },
      };

      if (this.props.uniqueId != null) {
        fieldInputConfig.headers.UniqueId = this.props.uniqueId;
      }

      let fieldInputs = (
        await axios.get(
          Config.baseApiUrl + "fieldInputs/" + this.props.formTypeId,
          fieldInputConfig
        )
      ).data;

      const customerSuppliedPlate = fieldInputs.find((fi) => fi.fieldName === "customerSuppliedPlate")?.stringData;
      const customerSuppliedLock = fieldInputs.find((fi) => fi.fieldName === "customerSuppliedLock")?.stringData;
      const customerSuppliedValve = fieldInputs.find((fi) => fi.fieldName === "customerSuppliedValve")?.stringData;

      this.setState({
        orderNumber: clinicInfoData.orderId,
        soNumber: soNumber.data,
        poNumber: clinicInfoData.poNumber,
        patientName: patientInfo1Data.patientName,
        patientId: patientInfo1Data.patientId,
        accountNumber: clinicInfoData.accountNumber,
        clinicName: clinicInfoData.clinicName,
        prosthetistName: clinicInfoData.prosthetistName,
        email: clinicInfoData.email,
        shippingAddress1: clinicInfoData.shippingAddress1,
        shippingAddress2: clinicInfoData.shippingAddress2,
        city: clinicInfoData.city,
        stateName: clinicInfoData.stateName,
        zip: clinicInfoData.zip,
        phone: this.formatPhone(clinicInfoData.phone),
        contactMethodName: clinicInfoData.contactMethodName,
        shippingCarrierName: clinicInfoData.shippingCarrierName,
        shippingMethodName: clinicInfoData.shippingMethodName,
        isBilateral: this.getYesNo(patientInfo1Data.isBilateral),
        notes: notes.data,
        estimatedShipDate: estimatedShipDate,
        patientInfo1UOM: patientInfo1Data.fieldInputs.find(
          (fi) => fi.fieldName === "patientInfo1UOM"
        ).fieldOptionId,
        patientInfo1UOMName: patientInfo1Data.fieldInputs.find(
          (fi) => fi.fieldName === "patientInfo1UOM"
        ).fieldOptionName,
        amputationLevel: fieldInputs.find(
          (fi) => fi.fieldName === "amputationLevel"
        ).fieldOptionName,
        kLevel: fieldInputs.find((fi) => fi.fieldName === "kLevel")
          .fieldOptionName,
        footDirection: fieldInputs.find(
          (fi) => fi.fieldName === "footDirection"
        ).fieldOptionName,

        itemsSentIn: fieldInputs.find((fi) => fi.fieldName === "itemsSentIn")
          .stringData,
        customerSuppliedPlate: (customerSuppliedPlate === "" || customerSuppliedPlate === null) ? "No Value Entered" : customerSuppliedPlate,
        customerSuppliedLock: (customerSuppliedLock === "" || customerSuppliedLock === null) ? "No Value Entered" : customerSuppliedLock,
        customerSuppliedValve: (customerSuppliedValve === "" || customerSuppliedValve === null) ? "No Value Entered" : customerSuppliedValve,
      });

      this.setState({
        height: this.getHeightText(
          patientInfo1Data.fieldInputs.find((fi) => fi.fieldName === "height")
            .numericData
        ),
        weight: this.getWeightText(
          patientInfo1Data.fieldInputs.find((fi) => fi.fieldName === "weight")
            .numericData
        ),
      });
    } catch (error) {
      //   this.props.handleError(new LoadFailureResult());
    }
    this.setState({ isLoaded: true });
  }
  async loadData2() {
    try {
      super.loadData();
      let fieldInputConfig = {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token"))?.access_token,
        },
        params: {
          fieldNames: [
            "uOM",
            "mPTToFloor",
            "pmlWidth",
            "residualLength",
            "aboveMPT15cm",
            "aboveMPT10cm",
            "aboveMPT5cm",
            "aboveMPT0cm",
            "belowMPT5cm",
            "belowMPT10cm",
            "belowMPT15cm",
            "belowMPT20cm",
            "pml",
            "ml",
            "ap",
            "iTToFloor",
            "kCToFloor",
            "tight5cm",
            "tight10cm",
            "tight15cm",
            "tight20cm",
            "tight25cm",
            "tight30cm",
            "loose5cm",
            "loose10cm",
            "loose15cm",
            "loose20cm",
            "loose25cm",
            "loose30cm",
            "limbLength",
            "femurLength",
            "flexion",
            "adduction",
            "castShippedSeparately",
            "modification",
            "modificationPercentage",
            "modificationPly",
            "trimline",
            "brim",
            "brimOther",
            "shapeCreation",
            "lock",
            "lockType",
            "valve",
            "mountingPlate",
            "material",
            "notes",
            "foamCarving",
            "insertMaterial",
            "AKLynValveOption",
          ],
        },
      };

      if (this.props.uniqueId != null) {
        fieldInputConfig.headers.UniqueId = this.props.uniqueId;
      }

      let fieldInputs = (
        await axios.get(
          Config.baseApiUrl + "fieldInputs/" + this.props.formTypeId,
          fieldInputConfig
        )
      ).data;
      let newState = this.state;

      newState["uOM"] = fieldInputs.find(
        (fi) => fi.fieldName === "uOM"
      ).fieldOptionName;
      this.setNumericProperty(newState, fieldInputs, "mPTToFloor");
      this.setNumericProperty(newState, fieldInputs, "pmlWidth");
      this.setNumericProperty(newState, fieldInputs, "residualLength");
      this.setNumericProperty(newState, fieldInputs, "aboveMPT15cm");
      this.setNumericProperty(newState, fieldInputs, "aboveMPT10cm");
      this.setNumericProperty(newState, fieldInputs, "aboveMPT5cm");
      this.setNumericProperty(newState, fieldInputs, "aboveMPT0cm");
      this.setNumericProperty(newState, fieldInputs, "belowMPT5cm");
      this.setNumericProperty(newState, fieldInputs, "belowMPT10cm");
      this.setNumericProperty(newState, fieldInputs, "belowMPT15cm");
      this.setNumericProperty(newState, fieldInputs, "belowMPT20cm");
      this.setNumericProperty(newState, fieldInputs, "pml");
      this.setNumericProperty(newState, fieldInputs, "ml");
      this.setNumericProperty(newState, fieldInputs, "ap");
      this.setNumericProperty(newState, fieldInputs, "iTToFloor");
      this.setNumericProperty(newState, fieldInputs, "kCToFloor");
      this.setNumericProperty(newState, fieldInputs, "tight5cm");
      this.setNumericProperty(newState, fieldInputs, "tight10cm");
      this.setNumericProperty(newState, fieldInputs, "tight15cm");
      this.setNumericProperty(newState, fieldInputs, "tight20cm");
      this.setNumericProperty(newState, fieldInputs, "tight25cm");
      this.setNumericProperty(newState, fieldInputs, "tight30cm");
      this.setNumericProperty(newState, fieldInputs, "loose5cm");
      this.setNumericProperty(newState, fieldInputs, "loose10cm");
      this.setNumericProperty(newState, fieldInputs, "loose15cm");
      this.setNumericProperty(newState, fieldInputs, "loose20cm");
      this.setNumericProperty(newState, fieldInputs, "loose25cm");
      this.setNumericProperty(newState, fieldInputs, "loose30cm");
      this.setNumericProperty(newState, fieldInputs, "limbLength");
      this.setNumericProperty(newState, fieldInputs, "femurLength");
      this.setNumericProperty(newState, fieldInputs, "flexion");
      this.setNumericProperty(newState, fieldInputs, "adduction");
      this.setBooleanProperty(newState, fieldInputs, "castShippedSeparately");
      newState.shapeCreationNotes = fieldInputs.find(
        (fi) => fi.fieldName === "notes"
      ).stringData;

      this.setArrayProperty(newState, fieldInputs, "modification");
      this.setArrayProperty(newState, fieldInputs, "modificationPercentage");
      this.setArrayProperty(newState, fieldInputs, "modificationPly");
      this.setArrayProperty(newState, fieldInputs, "trimline");
      this.setArrayProperty(newState, fieldInputs, "socketStyle");
      this.setArrayProperty(newState, fieldInputs, "brim");
      this.setArrayProperty(newState, fieldInputs, "brimOther");
      this.setArrayProperty(newState, fieldInputs, "shapeCreation");
      this.setArrayProperty(newState, fieldInputs, "foamCarving");
      this.setArrayProperty(newState, fieldInputs, "lock");
      this.setArrayProperty(newState, fieldInputs, "lockType");
      this.setArrayProperty(newState, fieldInputs, "valve");
      this.setArrayProperty(newState, fieldInputs, "insertMaterial");
      this.setArrayProperty(newState, fieldInputs, "mountingPlate");
      this.setArrayProperty(newState, fieldInputs, "material");
      this.setArrayProperty(newState, fieldInputs, "AKLynValveOption");

      this.setState(newState);
    } catch (error) {
      //   this.props.handleError(new LoadFailureResult());
    }
  }
  async saveData() {
    let config = {};
    config.headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("token")).access_token,
    };

    let soNumber = { 
      data: this.state.pendingSoNumber,
      uniqueId: this.props.uniqueId 
    };

    this.setState({ soNumber: soNumber.data });

    return axios.post(Config.baseApiUrl + "soNumbers/" + this.props.formTypeId, soNumber, config);
  }

  // Only input field is so number
  onInputChange(e) {
    let newSoData = e.target.value;
    this.setState({
      pendingSoNumber: newSoData,
      hasDataChanged: true,
    });
  }

  formatPhone(phone) {
    if (phone.length === 12) {
      return (
        "(" +
        phone.substr(2, 3) +
        ") " +
        phone.substr(5, 3) +
        "-" +
        phone.substr(8, 4)
      );
    }

    return phone;
  }

  getHeightText(height) {
    if (this.state.patientInfo1UOM === this.patientInfo1UomMetric) {
      return height + " cm";
    } else {
      return Math.floor(height / 12) + "' " + (height % 12) + '"';
    }
  }

  getWeightText(weight) {
    if (this.state.patientInfo1UOM === this.patientInfo1UomMetric) {
      return weight + " kg";
    } else {
      return weight + " lbs";
    }
  }


  formatShipDate(shipDate) {
    if (!shipDate) {
      return "";
    }
    return `${shipDate.month}/${shipDate.day}/${shipDate.year}`;
  }

  setNumericProperty(obj, fieldInputs, propertyName) {
    obj[propertyName] =
      fieldInputs.find((fi) => fi.fieldName === propertyName)?.numericData ?? 0;
  }

  setStringProperty(obj, fieldInputs, propertyName) {
    obj[propertyName] = fieldInputs.find(
      (fi) => fi.fieldName === propertyName
    )?.stringData;
  }

  setBooleanProperty(obj, fieldInputs, propertyName) {
    obj[propertyName] = this.getYesNo(
      fieldInputs.find((fi) => fi.fieldName === propertyName)?.booleanData
    );
  }

  setArrayProperty(obj, fieldInputs, propertyName) {
    obj[propertyName] = fieldInputs.filter(
      (fi) => fi.fieldName === propertyName
    );
  }

  getFlexionLabel() {
    return this.state.flexion >= 0 ? "Flexion" : "Extension";
  }
  getAdductionLabel() {
    return this.state.adduction >= 0 ? "Adduction" : "Abduction";
  }

  displaySONumber() {
    if (this.state.soNumber !== null) {
      return this.simpleDetail("Sales Order #:", this.state.soNumber);
    } else {
      return (
        <div className="detail">
          <div className="detailContentWrapper">
            <div className="content">
              <InputTextField
                label="Sales Order #"
                variant="outlined"
                placeholder="#"
                required={true}
                type="text"
                value={this.state.pendingSoNumber}
                error={false}
                onChange={(e) => this.onInputChange(e)}
              />
              <Button
                text="Save"
                disabled={false}
                onClick={() => this.saveData()}
              />
            </div>
          </div>
        </div>
        
      );
    }
  }


  render() {
    if (!this.state.isLoaded) {
      return (
        <div className="loader">
          <ClipLoader color="#000000" size={40} />
        </div>
      );
    } else {
      return (
        <>
          <div
            className={`internalReviewWrapper reviewWrapper ${
              this.props.isBilateral ? "bilateralWrapper" : ""
            }`}
          >

            <div className="reviews" ref={this.targetRef}>
              <div>
                {!this.props.showOrderSummary && (
                  <div className="summaryName">
                    {this.props.isBilateral && (
                      <div className="bileralName">
                        <h2>{this.props.bilateralName}</h2>
                      </div>
                    )}
                    {!this.props.isBilateral && <h2>{this.props.formName}</h2>}
                  </div>
                )}
                <div className="summaaryHeader">
                  <h2>
                    {this.props.name}
                    {this.props.isBilateral &&
                      " (Order " + this.props.orderNumber + ")"}
                  </h2>
                </div>
              </div>


              <div className="information">

                <div className="subDetail">

                  <div className="detailWrapper">
                    <div className="rightContent">
                      {this.detailsBlock("Order Info",
                          this.simpleDetail("Patient ID", this.state.patientId),
                          this.simpleDetail("PO Number", this.state.poNumber),
                          this.displaySONumber(),
                          this.simpleDetail("Est. Ship Date", this.formatShipDate(this.state.estimatedShipDate)),
                          this.simpleDetail("Facility", this.state.clinicName),
                          this.simpleDetail("", 
                            <>{this.state.shippingAddress1} {this.state.shippingAddress2}, {this.state.city} {this.state.stateName} {this.state.zip}</>)
                      )}

                      {this.detailsBlock("Patient Info",
                        this.simpleDetail("Amputation Level", 
                          (this.props.formTypeId==3) ? "BK" : 
                          (this.props.formTypeId==4) ? "AK" : ""
                        ),
                        this.simpleDetail("Amputation Side", this.state.footDirection),
                        this.simpleDetail("Height", this.state.height),
                        this.simpleDetail("Weight", this.state.weight),
                        this.simpleDetail("K-Level", this.state.kLevel)
                      )}

                      {this.detailsBlock("Items sent in with socket",
                        (this.state.itemsSentIn !== "" && this.state.itemsSentIn !== null) ? 
                          <p>{this.state.itemsSentIn}</p>
                          : <p>No Value Entered</p>
                      )}

                      {this.detailsBlock("Notes",
                        !(this.state.notes === null && this.state.shapeCreationNotes === null) ?
                            <><p>{this.state.notes}</p><p>{this.state.shapeCreationNotes}</p></> :
                            <p>No Value Entered</p>
                      )}
                      
                    </div>

                    <div className="leftContent">
                      <div className="summaryName"><h2>Product Information</h2></div>

                      {this.detailsBlock("Socket Options",
                        this.optionalDetail("Material", this.makeFieldOutput(this.state.material)),
                        this.optionalDetail("Foam Carving", this.makeFieldOutput(this.state.foamCarving)),
                        this.simpleDetail("Insert Material", this.makeFieldOutput(this.state.insertMaterial) ?? "None Selected"),
                        this.optionalDetail("Trimline", this.makeFieldOutput(this.state.trimline)),
                      )}

                      {this.detailsBlock("Modification", 
                          this.state.modification[0]?.fieldOptionId !==
                              this.nomodificationId ? (
                              <>
                                {this.makeConditionalModificationFieldOutput(
                                  "Percentage",
                                  this.state.modificationPercentage,
                                  "numericData"
                                )}
                                {this.makeConditionalModificationFieldOutput(
                                  "Ply",
                                  this.state.modificationPly,
                                  "numericData"
                                )}
                              </>) : <span>No Modification</span>
                      )}

                      {this.detailsBlock("Angles",
                        this.simpleDetail(this.getFlexionLabel(), <>{Math.abs(this.state.flexion)}°</>),
                        this.simpleDetail(this.getAdductionLabel(), <>{Math.abs(this.state.adduction)}°</>)
                      )}

                      {this.detailsBlock("Suspension",
                        this.optionalDetail("Lock", this.makeFieldOutput(this.state.lock),
                            <>{this.state.lock && 
                                this.state.lock[0].fieldOptionId === this.customerSuppliedLockId ?
                                  <div className="content">
                                    <span>Lock Name</span>
                                    <p>
                                      {this.state.customerSuppliedLock}
                                    </p>
                                  </div> : <></>
                            }</>
                        ),
                        this.optionalDetail("Valve", this.makeFieldOutput(this.state.valve),
                            <>{this.state.valve && 
                                this.state.valve[0].fieldOptionId === this.customerSuppliedValveId ?
                                  <div className="content">
                                    <span>Valve Name</span>
                                    <p>
                                      {this.state.customerSuppliedValve}
                                    </p>
                                  </div> : <></>
                            }</>
                        ),
                        this.optionalDetail("Mounting Plate", this.makeFieldOutput(this.state.mountingPlate),
                            <>{this.state.mountingPlate && 
                                this.state.mountingPlate[0].fieldOptionId === this.customerSuppliedPlateId ?
                                  <div className="content">
                                    <span>Material Name</span>
                                    <p>
                                      {this.state.customerSuppliedPlate}
                                    </p>
                                  </div> : <></>
                            }</>
                        ),
                      )}
                    </div>
                  </div>
                </div>
              </div>
              
            </div>
          </div>
        </>
      );
    }
  }


  getIntervalFromCM(cm) {
    if (this.state.uOM === "inches") {
      return `${cm / 2.5} in`;
    } else {
      return `${cm} cm`;
    }
  }

  
  detailsBlock(title, ...entries) {
    return (<div className="detail">
      <h4>{title}</h4>
      <div className="detailContentWrapper">
        {entries}
      </div>
    </div>);
  }

  simpleDetail(title, content) {
    return (<div className="content">
      <span>{title}</span>
      <p>{content}</p>
    </div>)
  }

  optionalDetail(title, content, secondaryContent=null) {
    if(content !== null) {
      return (<>
        <div className="content">
          <span>{title}</span>
          <div>{content}</div>
        </div>
        {secondaryContent}
      </>);
    } else {
      return <></>;
    }
  }
}

export default InternalReview;
